import { createRouter, createWebHistory } from 'vue-router';
import Storage from '@/utils/storage';
import SCM from './module/SCM.js'
const routes = [{
  path: '/',
  redirect: '/CustAccoutManage'
}, {
  path: '/LoginPage',
  name: 'LoginPage',
  component: () => import('../views/LoginPage.vue')
}, {
  path: '/PageLayout',
  name: 'PageLayout',
  component: () => import('../views/default/PageLayout.vue'),
  children: [...SCM]
}];
const router = createRouter({
  history: createWebHistory(window.__POWERED_BY_QIANKUN__ ? '/scm/' : '/#/'),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '客户协同平台';
  if (to.path !== '/LoginPage') {
    const token = Storage.getCookie('TOKEN');
    const userInfo = Storage.getLocalStorage('USER_INFO');
    if (!token || !userInfo) {
      next('/LoginPage');
      return;
    }
    if ((!userInfo.roleName || userInfo.roleName !== 'ADMIN') && to.path !== '/DownloadFile') {
      next('/DownloadFile')
      return;
    }
  }
  next();
});

export default router;